import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import _ from 'lodash';
import Sidebar from 'react-sidebar';

import DesktopHeader from '../DesktopHeader';
import DesktopFooter from '../footer/DesktopFooter';

import SidebarContent from '../../common/sidebar/SidebarContent';
import useSidebar from '../../common/sidebar/useSidebar';

import Loader from '../../common/loader/Loader';
import Alert from '../../common/Alert';

import { getDesktopSidebarStyles } from '../../../utils/sidebar-utils';
import {
  getCourseColor,
  courseTypeToString,
  courseLevelToString,
  getWhiteCourseIconPath,
} from '../../../utils/course-utils';

const CoursesPage = () => {
  const history = useHistory();

  const [courses, setCourses] = useState({});
  const [status, setStatus] = useState({ isLoading: false, isError: false });

  useEffect(() => {
    setStatus({ isLoading: true, isError: false });
    axios
      .get('/api/v1/courses/published')
      .then(response => {
        setCourses(_.groupBy(response.data.courses, x => courseTypeToString(x.type)));
        setStatus({ isLoading: false, isError: false });
      })
      .catch(() => {
        setStatus({ isLoading: false, isError: true });
      });
  }, []);

  const navigateToCourse = id => () => {
    history.push(`/course/${id}`);
  };

  const { isSidebarOpen, setIsSidebarOpen, openSidebar, closeSidebar } = useSidebar();

  return (
    <Sidebar
      open={isSidebarOpen}
      onSetOpen={setIsSidebarOpen}
      sidebar={<SidebarContent closeSidebar={closeSidebar} />}
      styles={getDesktopSidebarStyles()}
    >
      <DesktopHeader openSidebar={openSidebar} />
      <Loader isVisible={status.isLoading} />
      <div className="desktop-page">
        <div className="tutorium-container">
          <p className="desktop-page-header">Tutorium courses</p>
          {status.isError && <Alert isError message="An error occured" />}
        </div>
      </div>

      <div className="courses-content">
        <div className="tutorium-container">
          {_.map(courses, (list, key) => {
            return (
              <div key={key} className="pt-30px">
                <p className="courses-content-group-title">{key}</p>
                <div className="courses-content-group">
                  {list.map(course => {
                    return (
                      <div
                        key={course._id}
                        className="courses-content-course-container"
                        onClick={navigateToCourse(course._id)}
                      >
                        <div
                          className="courses-content-course-header"
                          style={{ background: getCourseColor(course.type) }}
                        >
                          <div className="is-flex align-items-center">
                            <img src={getWhiteCourseIconPath(course.type)} />
                            <p className="ml-10px">{key}</p>
                          </div>
                          <p>{course.webinarsCount} webinars</p>
                        </div>
                        <div className="courses-content-course-body">
                          <p className="courses-content-course-name">{course.name}</p>
                          <p>{course.description}</p>
                        </div>
                        <div className="courses-content-course-footer">
                          <p>LEVEL: {courseLevelToString(course.level)}</p>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <DesktopFooter />
    </Sidebar>
  );
};

export default CoursesPage;
